import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { CmsEntities, bindToContent } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { SeoLinks } from 'site-modules/shared/components/seo-links/seo-links';

export class DealerSeoLinksUI extends Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.content !== this.props.content;
  }

  render() {
    const { content, className } = this.props;
    return (
      <SeoLinks
        content={content.child('popular-vehicles')}
        className={className}
        headingClasses="pb-1 text-start size-30"
      />
    );
  }
}

const stateToPropsConfig = {
  content: bindToContent('editorial/includes/dywai-footer-links'),
};

DealerSeoLinksUI.propTypes = {
  content: CmsEntities.Content,
  className: PropTypes.string,
};
DealerSeoLinksUI.defaultProps = {
  content: DEFAULT_CONTENT,
  className: '',
};

export const DealerSeoLinks = connectToModel(DealerSeoLinksUI, stateToPropsConfig);
